import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import caseDocumentService from "../services/documents-service";

export const caseDocumentSearchQuery = z.object({
	search: z.string().optional(),
	type: z.string().optional().nullable(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
	branch_id: z.string().optional(),
});

export const caseDocumentsQueryOptions = (search?: z.infer<typeof caseDocumentSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_documents", search],
		queryFn: () => caseDocumentService.list(transformSearch(search, ["type", "search", "branch_id"])),
		...options,
	});
};
